import {
    FETCH_NOTIFICATIONS_REQUEST,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILURE,
    MARK_NOTIFICATION_READ_REQUEST,
    MARK_NOTIFICATION_READ_SUCCESS,
    MARK_NOTIFICATION_READ_FAILURE,
} from "../actions/types";

const initialState = {
    notifications: [],
    total: 0,
    page: 1,
    hasMore: false,
    loading: false,
    error: null,
};

const notificationReducer =
    (
        state = initialState,
        action
    ) => {
        switch (
        action.type
        ) {
            case FETCH_NOTIFICATIONS_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case FETCH_NOTIFICATIONS_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    notifications:
                        action
                            .payload
                            .notifications,
                    total:
                        action
                            .payload
                            .total,
                    page:
                        action
                            .payload
                            .page,
                    hasMore:
                        action
                            .payload
                            .hasMore,
                };

            case FETCH_NOTIFICATIONS_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };

            case MARK_NOTIFICATION_READ_REQUEST:
                return {
                    ...state,
                    loading: true,
                };

            case MARK_NOTIFICATION_READ_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    notifications:
                        state.notifications.map(
                            (
                                notification
                            ) =>
                                notification.notification_id ===
                                    action.payload
                                    ? {
                                        ...notification,
                                        is_read: true,
                                    }
                                    : notification
                        ),
                };

            case MARK_NOTIFICATION_READ_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };

            default:
                return state;
        }
    };

export default notificationReducer;